export enum WebSocketAction {
  VQA_QUERY = 'VQA_query',
  NOTIFICATION = 'notification',
  HEARTBEAT = 'heartbeat'
}